const config = {
API_URL: "https://api.rbkassistance.com"
};
export default config;
